exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/**\n*  以下为修改菜单字体大小\n*/\n.toLarge[data-v-2d2bbdc2] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  -o-text-overflow: ellipsis;\n  overflow: hidden;\n}", ""]);

// exports
